module.exports = __webpack_public_path__ + "img/hzico_2.d25ab285.jpg";